import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import type { MobileNavLink } from '../MobileNavMenuData';

const activeLinks = [
  { title: 'Your Guest List', path: '/wedding/manage/guests/all' },
  { title: 'Your RSVPs', path: '/wedding/manage/guests/rsvps/overview' },
  { title: 'Your Contact Collector', path: '/wedding/manage/guests/collection-link' },
  { title: 'Your Events', path: '/wedding/manage/events' },
];
const buildGuestList = {
  title: 'Build Guest List',
  path: '/wedding/manage/guests/build',
};
const inactiveLinks = [
  { title: 'Add Guests', path: '/wedding/manage/guests/all' },
  {
    title: 'Get Guest Addresses',
    path: '/wedding/manage/guests/collection-link',
  },
  { title: 'Create an Event', path: '/wedding/manage/events' },
];

const aboutLinks = [
  { title: 'About Guest List', path: '/wedding-planning/guests' },
  {
    title: 'Guest List FAQs',
    path: '/faq/category/115000345711-guest-list',
  },
];

export default function getMobileGuestListMenuData(userContext: UserContext): MobileNavLink[][] {
  const guestList = Boolean(userContext.wedding_account?.guest_list_onboarding_completed);
  const activeGuestListLinks = [activeLinks, [buildGuestList], aboutLinks];
  const inactiveGuestListLinks = [inactiveLinks, aboutLinks];
  return guestList ? activeGuestListLinks : inactiveGuestListLinks;
}
